import React from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "store";

import { handleUpdateFields, PresetItem } from "store/players/presets/slice";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";
import { useSearchParams } from "react-router-dom";

interface PresetsMainTabProps {
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  readOnly?: boolean;
}

const PresetsMainTab: React.FC<PresetsMainTabProps> = ({
  fieldErrors,
  clearFieldError,
  readOnly,
}) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const payload = useAppSelector((store) => store.presets.payload);
  const [searchParams] = useSearchParams();

  const isEdit = Boolean(searchParams.get("entityId"));

  const handleData = (key: keyof PresetItem, value: string | boolean) => {
    dispatch(
      handleUpdateFields({
        [key]: value,
      }),
    );
  };

  return (
    <div className="preset-form-wrapper">
      <div className="preset-form-content">
        <div className="preset-form-main-row">
          <div className="preset-form--item">
            <InnerInput
              value={payload?.presetCode ?? ""}
              placeholder={t("presetCode")}
              label={t("presetCode")}
              type="text"
              id="preset-code"
              disabled={isEdit || readOnly}
              onChange={(e) => {
                handleData("presetCode", e);
                clearFieldError("presetCode");
              }}
              hasError={Boolean(fieldErrors?.["presetCode"])}
            />
          </div>

          <div className="preset-form--item">
            <InnerInput
              value={payload?.title ?? ""}
              placeholder={t("title")}
              label={t("title")}
              type="text"
              id="preset-title"
              onChange={(e) => {
                handleData("title", e);
                clearFieldError("title");
              }}
              hasError={Boolean(fieldErrors?.["title"])}
              disabled={readOnly}
            />
          </div>
        </div>

        <div className="preset-form--item">
          <InnerInput
            maxCodePoints={2500}
            value={payload?.description ?? ""}
            placeholder={t("description")}
            label={t("description")}
            type="textarea"
            id="preset-description"
            onChange={(e) => {
              handleData("description", e);
              clearFieldError("description");
            }}
            hasError={Boolean(fieldErrors?.["description"])}
            disabled={readOnly}
          />
        </div>

        <div className="preset-form-switcher">
          <SwitchBtn
            activeTxt={t("active")}
            notActiveTxt={t("hidden")}
            isActive={!!payload?.isActive}
            handleClick={() => {
              handleData(
                "isActive",
                payload?.isActive ? !payload?.isActive : true,
              );

              clearFieldError("isActive");
            }}
            hasError={Boolean(fieldErrors?.["isActive"])}
            disabled={readOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default PresetsMainTab;
